export const getErrorMessage = (
  errorKey: string,
  errors: { [key: string]: { message?: string } }
) => errors[errorKey]?.message
